import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={28}
    height={26}
    viewBox="0 0 36 34"
    fill="none"
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line
      x1={2.95418}
      y1={1.29289}
      x2={34.9542}
      y2={33.2929}
      stroke="#BC9B6A"
      strokeWidth={2}
    />
    <line
      x1={1.53996}
      y1={33.2929}
      x2={33.54}
      y2={1.29289}
      stroke="#BC9B6A"
      strokeWidth={2}
    />
  </svg>
);
export default SVGComponent;
